export const REDUCER_KEYS = {
  THEME: 'themeSlice',
  ALERT: 'alertSlice',
  USER: 'userSlice',
  IN_PLAY: 'inPlaySlice',
};
